import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH SUBMENU ITEM TO EDIT ********************
export const fetchSubmenuItem = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_SUBMENU_ITEM_LOADING,
			payload: true
		});

		const response = await services.get(`/menus/${id}`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_SUBMENU_ITEM_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_SUBMENU_ITEM_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
